import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialTipologiaRappresentanteState } from './tipologia_rappresentante.state';
import { getTipologiaRappresentante } from './tipologia_rappresentante.utility';
import { GetTipologiaRappresentanteGQL } from '../../_graphql/generated';

export const TipologiaRappresentanteStore = signalStore(
  { providedIn: 'root' },
  withState(initialTipologiaRappresentanteState),
  withProps(() => ({
    getter: inject(GetTipologiaRappresentanteGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getTipologiaRappresentante(injector, store, getter),
  })),
);
